import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(({ palette }) => ({
  button_period: {
    "&:first-child": {
      borderRadius: "5px 0 0 5px",
    },
    "&:last-child": {
      borderRadius: "0 5px 5px 0",
    },
    "&:not(:first-child)": {
      borderLeftWidth: 0,
    },
    borderRadius: 0,
    flexBasis: "100%",
  },
  "button_period--mobile": {
    "&:first-child": {
      borderRadius: "5px 5px 0 0",
    },
    "&:last-child": {
      borderRadius: "0 0 5px 5px",
    },
    "&:not(:first-child)": {
      borderTop: 0,
    },
    borderLeftWidth: "1px !important",
  },
  button_period__badge: {
    background: palette.secondary.main,
    borderRadius: 8,
    color: palette.secondary.contrastText,
    left: "50%",
    paddingLeft: 8,
    paddingRight: 8,
    position: "absolute",
    top: -10,
    transform: "translate(-50%)",
  },
  button_period__badge__text: {
    fontSize: 10,
  },
}));
